import React, { useEffect, useRef, useState } from "react";
import { api, downloadAuthed, API } from "@/lib/api";
import { fmtDate } from "@/lib/format";
import { PageHeader, EmptyState, Field } from "@/components/common";
import { Button } from "@/components/ui/button";
import { Card } from "@/components/ui/card";
import { Table, TableHeader, TableRow, TableHead, TableBody, TableCell } from "@/components/ui/table";
import { FolderOpen, Upload, Download, FileText } from "lucide-react";
import { toast } from "sonner";

const Sel = (p) => <select {...p} className="flex h-10 w-full rounded-md border border-input bg-background px-3 text-sm focus:outline-none focus:ring-2 focus:ring-indigo-500" />;
const ENTITIES = ["property", "tenant", "agreement", "invoice", "expense"];

export default function Documents() {
  const [items, setItems] = useState([]);
  const [entityType, setEntityType] = useState("agreement");
  const fileRef = useRef();
  const load = () => api.get("/documents").then(setItems).catch(() => {});
  useEffect(() => { load(); }, []);

  const upload = async (e) => {
    const file = e.target.files[0];
    if (!file) return;
    const fd = new FormData();
    fd.append("file", file); fd.append("entity_type", entityType); fd.append("entity_id", "");
    try { await api.post("/documents", fd, { headers: { "Content-Type": "multipart/form-data" } }); toast.success("Document uploaded"); load(); }
    catch { toast.error("Upload failed"); }
    if (fileRef.current) fileRef.current.value = "";
  };
  const kb = (b) => (b > 1048576 ? `${(b / 1048576).toFixed(1)} MB` : `${(b / 1024).toFixed(0)} KB`);

  return (
    <div>
      <PageHeader title="Documents" subtitle="Agreements, KYC, bills & receipts" testid="documents-header">
        <Sel value={entityType} onChange={(e) => setEntityType(e.target.value)} data-testid="doc-entity-type" className="w-40">{ENTITIES.map((e) => <option key={e} value={e}>{e[0].toUpperCase() + e.slice(1)}</option>)}</Sel>
        <input ref={fileRef} type="file" className="hidden" onChange={upload} accept=".pdf,.jpg,.jpeg,.png" data-testid="doc-file-input" />
        <Button data-testid="upload-doc-btn" onClick={() => fileRef.current?.click()} className="bg-indigo-600 hover:bg-indigo-700"><Upload className="w-4 h-4 mr-1" /> Upload</Button>
      </PageHeader>
      {items.length === 0 ? <EmptyState icon={FolderOpen} title="No documents" hint="Upload PDFs or images (agreements, bills, KYC)." /> : (
        <Card className="border-slate-200 shadow-sm overflow-x-auto">
          <Table>
            <TableHeader><TableRow className="bg-slate-50"><TableHead>Name</TableHead><TableHead>Linked To</TableHead><TableHead>Size</TableHead><TableHead>Uploaded</TableHead><TableHead className="text-right">Actions</TableHead></TableRow></TableHeader>
            <TableBody>
              {items.map((d) => (
                <TableRow key={d.id} className="hover:bg-slate-50/50">
                  <TableCell className="flex items-center gap-2"><FileText className="w-4 h-4 text-slate-400" />{d.name}</TableCell>
                  <TableCell className="capitalize"><span className="px-2 py-0.5 rounded bg-slate-100 text-xs">{d.entity_type}</span></TableCell>
                  <TableCell className="text-xs">{kb(d.size)}</TableCell>
                  <TableCell className="text-xs">{fmtDate(d.at)}</TableCell>
                  <TableCell className="text-right"><Button size="sm" variant="ghost" title="Download document" onClick={() => downloadAuthed(`/documents/${d.id}/download`, d.name)}><Download className="w-4 h-4" /></Button></TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </Card>
      )}
    </div>
  );
}
